export default "__VITE_ASSET__Cfzrsf1E__"